<script>
    import {onMount} from 'svelte';
    import gsap from "gsap";
    import {labels, mainTimeline} from "../timelines/main-timeline";
    import Spotlight from "./Elements/Spotlight.svelte";

    const timeline = gsap.timeline();

    let spotlight;

    const {
        planetsStart,
        planetsEnd,
        gnosisStart,
        telescopeStart,
        lighthouseEnd,
        pathEnd,
        magnifyingGlassStart,
        gnosisFinalStart,
    } = labels;

    onMount(() => {
        const initialDelay = 5.02;

        mainTimeline
            .fromTo(spotlight,
                {
                    scale: 0.3,
                    opacity: 0,
                    y: -50,
                    transformOrigin: 'center',
                }, {
                    scale: 1,
                    opacity: 1,
                    y: -50,
                    duration: 1.5,
                    ease: 'BounceOut'
                }, planetsStart)
            .fromTo(
                spotlight,
                {
                    y: 100,
                },
                {
                    opacity: 1,
                    scale: 2,
                    duration: 1
                }, planetsEnd + '+=0.2')
            .to(spotlight, {
                scale: 0.5,
                duration: 1.5
            }, '>')
            .to(spotlight, {
                opacity: 0,
                duration: 1,
            }, `<`)
            .to(
                spotlight,
                {
                    opacity: 1,
                    scale: 0.5,
                    duration: 2.5
                }, telescopeStart
            )
            .to(
                spotlight,
                {
                    opacity: 0,
                    scale: 0,
                    duration: 2.5
                }, lighthouseEnd
            ).to(
            spotlight,
            {
                opacity: 1,
                scale: 0.5,
                duration: 2.5
            }, magnifyingGlassStart)
            .to(
                spotlight,
                {
                    opacity: 0,
                    scale: 0,
                    duration: 2.5
                }, gnosisFinalStart
            );

        mainTimeline.add(timeline, initialDelay)

    });

</script>

<g style="transform-origin: center" bind:this={spotlight} width="1175" height="1080">
    <g style="opacity: 0.2">
        <Spotlight />
    </g>
</g>
